import { cn } from '@/lib/utils';
import { useTranslation } from '@/i18n';

interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { language, setLanguage } = useTranslation();

  return (
    <div className={cn('flex gap-2', className)}>
      <LangButton 
        active={language === 'de'} 
        onClick={() => setLanguage('de')}
      >
        DE
      </LangButton>
      <LangButton 
        active={language === 'en'} 
        onClick={() => setLanguage('en')}
      >
        EN
      </LangButton>
    </div>
  );
}

function LangButton({ 
  active, 
  onClick, 
  children 
}: { 
  active: boolean; 
  onClick: () => void; 
  children: React.ReactNode 
}) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'px-3 py-1 rounded text-xs font-bold transition-all',
        active 
          ? 'bg-ukonnx-green text-bg-deep' 
          : 'bg-transparent border border-border-dark text-text-muted hover:text-text-primary'
      )}
    >
      {children}
    </button>
  );
}
